import { DateObject } from '@capsicum/common';

// Returns a string with the date that only includes the year if it's not the current year
export const formatShortDate = (dateTime: DateObject | number | string, currentYear: number): string => {
	const date = new DateObject(dateTime);

	let format = 'D MMM';

	if (date.getFullYear() !== currentYear) {
		format = 'D MMM YYYY';
	}

	return date.format(format).toUpperCase();
};
